import { Flex, Text } from "@simplybusiness/mobius";

export type AnnualPremiumProps = {
  premium: string;
  message?: string;
};

export const AnnualPremium = ({ premium, message }: AnnualPremiumProps) => {
  return (
    <Flex alignItems="baseline" flexWrap="wrap" columnGap="xxs">
      {message && (
        <Text
          variant="small"
          className="mobius-quote-card__pricing-unavailable-installment"
        >
          {message}
        </Text>
      )}
      <Flex
        data-testid="unavailable-monthly-installment-amount"
        alignItems="baseline"
        columnGap="xxs"
      >
        <Text
          elementType="span"
          className="mobius-quote-card__pricing-primary-amount --is-uk"
        >
          {premium}
        </Text>
        <Text
          elementType="span"
          variant="small"
          className="mobius-quote-card__pricing-period-suffix --is-uk"
        >
          /&nbsp;annual
        </Text>
      </Flex>
    </Flex>
  );
};
